
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.visually-hidden{
  clip:rect(0 0 0 0);
  -webkit-clip-path:inset(50%);
          clip-path:inset(50%);
  height:1px;
  overflow:hidden;
  position:absolute;
  white-space:nowrap;
  width:1px;
}

:host{
  font-family:var(--ff-body);
  font-size:var(--fs-base);
}

@media (min-width: 768px){

:host{
    font-size:var(--fs-lg);
}
  }

:host{
  color:var(--brand-dark-blue-900);
}

ul{
  display:flex;
  align-items:center;
  gap:10px;
}

.pager__item{
  width:2rem;
  height:2rem;
  display:flex;
  justify-content:center;
  align-items:center;
}

@media (min-width: 768px){

.pager__item{
    width:2.5rem;
    height:2.5rem
}
  }

@media (min-width: 1024px){

.pager__item{
    width:3rem;
    height:3rem
}
  }

.pager__item{
  border-radius:4px;
}

.pager__item:focus-within{
    outline:2px solid var(--brand-dark-blue-900);
    outline-offset:-2px;
  }

.pager__item:not(.pager__item.is-active):hover{
    background-color:var(--brand-dark-blue-900);
    color:var(--brand-white);
  }

.pager__item a{
    width:14px;
    height:24px;
    display:flex;
    justify-content:center;
    align-items:center;
  }

.pager__item a:focus{
      outline:none;
    }

.pager__item.is-active a{
      border-bottom:2px solid var(--brand-dark-blue-900);
    }

.pager__item--previous,
.pager__item--next{
  display:flex;
  align-items:center;
  justify-content:center;
  background-color:var(--brand-bright-blue-900);
}

.pager__item--previous outline-icon-baseline, .pager__item--next outline-icon-baseline{
    margin-left:1px;
  }

@media (min-width: 768px){

.pager__item--previous outline-icon-baseline, .pager__item--next outline-icon-baseline{
      transform:scale(1.2)
  }
    }

@media (min-width: 1024px){

.pager__item--previous outline-icon-baseline, .pager__item--next outline-icon-baseline{
      transform:scale(1.4)
  }
    }

.pager__item--previous span[aria-hidden='true'],
.pager__item--next span[aria-hidden='true']{
  clip:rect(0 0 0 0);
  -webkit-clip-path:inset(50%);
          clip-path:inset(50%);
  height:1px;
  overflow:hidden;
  position:absolute;
  white-space:nowrap;
  width:1px;
}

.pager__item--previous{
  transform:rotate(180deg);
}
`;